import React, { Fragment } from 'react';
import { Section } from '../../../components/Section/Section';
import { SectionMetaProvider } from '../../../components/Section/SectionMetaProvider';
import { Swimlane } from '../../../components/Swimlane/Swimlane';
import { SwimlaneTitle } from '../../../components/Swimlane/SwimlaneTitle';
import { Swipeable } from '../../../components/Swipeable/Swipeable';
import { MediaTeaserPlaceholder } from '../../../components/Teaser/MediaTeaser/MediaTeaserPlaceholder';
import { useVideoConfig } from '../../../config/VideoAppContext';
import { LatestMediaByShow } from './LatestMediaByShow';
import { TrendingByTopics } from './TrendingByTopics';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Swimlanes = ({
  videoDetail
}) => {
  const {
    videoDetail: config
  } = useVideoConfig();
  if (videoDetail) {
    const swimlanes = {
      LatestMediaByShow: videoDetail.show ? /*#__PURE__*/_jsx(LatestMediaByShow, {
        show: videoDetail.show,
        filterMediaUrn: videoDetail.urn
      }, 'LatestMediaByShow') : /*#__PURE__*/_jsx(Fragment, {}),
      // old recommended media disabled atm: https://srgssr-ch.atlassian.net/browse/PLAYNEXT-1276
      RecommendedMedia: /*#__PURE__*/_jsx(Fragment, {
        children: videoDetail?.topics && videoDetail.topics[0] && /*#__PURE__*/_jsx(TrendingByTopics, {
          topics: videoDetail.topics,
          filterMediaUrn: videoDetail.urn,
          filerShowUrn: videoDetail.show?.urn,
          titleKey: "videoDetailPage.recommendations"
        })
      }, 'RecommendedMedia'),
      TrendingByTopics: /*#__PURE__*/_jsx(Fragment, {
        children: videoDetail?.topics && videoDetail.topics[0] && /*#__PURE__*/_jsx(TrendingByTopics, {
          topics: videoDetail.topics,
          filterMediaUrn: videoDetail.urn
        })
      }, 'TrendingByTopics')
    };
    return /*#__PURE__*/_jsx(Fragment, {
      children: config.sections.map((name, index) => /*#__PURE__*/_jsx(SectionMetaProvider, {
        representationName: name,
        children: /*#__PURE__*/_jsx(Section, {
          needsTopSpacing: index === 0,
          children: swimlanes[name]
        })
      }, name))
    });
  }
  return /*#__PURE__*/_jsx(Fragment, {
    children: config.sections.map(value => /*#__PURE__*/_jsx(PlaceholderSwimlane, {}, value))
  });
};
const PlaceholderSwimlane = () => /*#__PURE__*/_jsx(Section, {
  needsTopSpacing: true,
  children: /*#__PURE__*/_jsxs(Swimlane, {
    children: [/*#__PURE__*/_jsx(SwimlaneTitle, {
      title: "\xA0"
    }), /*#__PURE__*/_jsx(Swipeable, {
      buttonPositionFactor: 9 / 16,
      placeholder: /*#__PURE__*/_jsx(MediaTeaserPlaceholder, {})
    })]
  })
});